import PhotoSwipe from 'components/photoswipe';
import PhotoSwipeLightbox from 'components/photoswipe-lightbox';

// const MobileLightbox = new PhotoSwipeLightbox({
//   gallery: '[id^="Mobile-upsell-"]',
//   children: 'a[itemprop="contentUrl"]',
//   wheelToZoom: true,
//   pswpModule: () => import('components/photoswipe'),
//   allowPanToNext: false
// });

// MobileLightbox.init();


// const DesktopLightbox = new PhotoSwipeLightbox({
//   gallery: '[id^="Desktop-upsell-"]',
//   children: 'a[itemprop="contentUrl"]',
//   wheelToZoom: true,
//   pswpModule: () => import('components/photoswipe'),
//   allowPanToNext: false
// });

// DesktopLightbox.init();


if (!customElements.get('product-upsell-element')) {
  customElements.define(
    'product-upsell-element',
    class ProductUpsell extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          gallery: '[id^="upsell-image-"]',
          children: '[itemprop="contentUrl"]'
        };
        this.blogLightboxOptions = null;
      }


      connectedCallback() {
        this.initBlogLightbox();
      }

      async initBlogLightbox() {
        try {
          this.blogLightboxOptions = {
            gallery: this.selectors.gallery,
            children: this.selectors.children,
            wheelToZoom: true,
            pswpModule: PhotoSwipe,
            allowPanToNext: false,
            mainClass: this.mainClass
          }
          this.blogLightbox = new PhotoSwipeLightbox(this.blogLightboxOptions);
          this.blogLightbox.init();
        } catch (error) {
          console.error('Error initializing PhotoSwipeLightbox:', error);
        }
      }
      get mainClass() {
        return this.dataset.mainClass;
      }
    }
  )
}